import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

import { FinnairOrder } from '@fcom/dapi/api/models';
import { ConfigService } from '@fcom/core/index';

import { ExpediaHotelsWidgetService } from '../../../../../services/expedia-hotels-widget/expedia-hotels-widget.service';

@Component({
  selector: 'fin-mmb-hotels-widget',
  templateUrl: './hotels-widget.component.html',
  styleUrls: ['./hotels-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MmbHotelsWidgetComponent implements OnInit {
  @Input({ required: true }) order$: Observable<FinnairOrder>;
  @Input({ required: true }) isWithin24HoursOfCreation: boolean;

  isSupportedLanguage$: Observable<boolean>;
  enablePre24HourWidget: boolean;

  constructor(
    private expediaHotelsWidgetService: ExpediaHotelsWidgetService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.enablePre24HourWidget = this.configService.cfg.enableHotelsMMBPre24Hours;
    this.isSupportedLanguage$ = this.expediaHotelsWidgetService.isSupportedLanguage$;
  }
}
